import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Recall Events'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Recall Events',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/recall-events',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
